module.exports = __webpack_public_path__ + "img/3.49488e8b.png";